export default __webpack_public_path__ + "static/media/frg--bbq-entertaining.4c4e53af.png";